var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { chain } from 'lodash';
import React from 'react';
import { CurrencyCode } from '../../../enum';
import { MULTISKILL_COLOR } from '../../annual/constants';
import { TableRow } from '../../common';
import { ExpandableRowLabel } from '../../common/tableHierarchy';
import { useReportAPI } from '../../report/selectors';
import { StyledFirstCell, StyledTableCell } from '../periodTable';
import { usePeriodReportChunkSize } from '../selectors';
import { INDENT_LEVELS, STICKIES } from './utils';
export var MainRow = function (_a) {
    var title = _a.title, rowColor = _a.rowColor, summaryColor = _a.summaryColor, _b = _a.isHideRow, isHideRow = _b === void 0 ? false : _b, _c = _a.averagePrecision, averagePrecision = _c === void 0 ? 0 : _c, data = _a.data, _d = _a.isIncludeTotal, isIncludeTotal = _d === void 0 ? false : _d, _e = _a.blankTotal, blankTotal = _e === void 0 ? false : _e, isCurrency = _a.isCurrency, _f = _a.isMultiskill, isMultiskill = _f === void 0 ? false : _f, _g = _a.nestLevel, nestLevel = _g === void 0 ? INDENT_LEVELS.metric : _g, props = __rest(_a, ["title", "rowColor", "summaryColor", "isHideRow", "averagePrecision", "data", "isIncludeTotal", "blankTotal", "isCurrency", "isMultiskill", "nestLevel"]);
    var reportData = useReportAPI()[0].data;
    var chunkSize = usePeriodReportChunkSize();
    var _h = reportData !== null && reportData !== void 0 ? reportData : {}, _j = _h.periodLength, periodLength = _j === void 0 ? 0 : _j, _k = _h.currency, currency = _k === void 0 ? CurrencyCode.Dollar : _k;
    var summary = React.useMemo(function () {
        return chain(periodLength)
            .times()
            .map(function (i) { var _a; return ({ value: Number((_a = data === null || data === void 0 ? void 0 : data[i]) !== null && _a !== void 0 ? _a : 0), hasData: (data === null || data === void 0 ? void 0 : data[i]) != null }); })
            .chunk(chunkSize)
            .map(function (arr) { return ({
            total: chain(arr).sumBy('value').round(averagePrecision).value(),
            avg: props.percentage
                ? chain(arr).filter('hasData').meanBy('value').value()
                : chain(arr).filter('hasData').meanBy('value').round(averagePrecision).value(),
            max: chain(arr).filter('hasData').map('value').max().value(),
        }); })
            .value();
    }, [averagePrecision, chunkSize, data, periodLength, props.percentage]);
    var getAvg = function (index) {
        if (props.calculated != null && index < props.calculated.length) {
            var fromApi = props.calculated[index];
            var n = fromApi == null ? Number.NaN : Number(fromApi);
            if (!Number.isNaN(n))
                return n;
        }
        if (!data)
            return undefined;
        if (props.summaryValue === 'max')
            return summary[index].max;
        if (props.summaryValue === 'total')
            return summary[index].total;
        return summary[index].avg;
    };
    return (_jsxs(TableRow, { children: [_jsx(StyledFirstCell, __assign({ color: rowColor, bold: props.bold, stickySizes: STICKIES, "aria-label": nestLevel }, { children: _jsx(ExpandableRowLabel, __assign({ expanded: props.showDetails, onToggle: isHideRow ? props.onShowRow : undefined, bold: props.bold }, { children: _jsx(Box, __assign({ component: "span" }, { children: title })) })) })), summary.map(function (item, year, arr) {
                var startIdx = chunkSize * year;
                return (_jsxs(React.Fragment, { children: [(data ? data.slice(startIdx, startIdx + chunkSize) : new Array(chunkSize).fill(null)).map(function (value, i) { return (_jsx(StyledTableCell, { color: isMultiskill ? MULTISKILL_COLOR : rowColor, value: value, percentage: props.percentage, currency: isCurrency ? currency : undefined, bold: props.bold, decimal: averagePrecision }, "year-".concat(year, "-period-").concat(startIdx + i))); }), isIncludeTotal && (_jsx(StyledTableCell, { color: isMultiskill ? MULTISKILL_COLOR : summaryColor !== null && summaryColor !== void 0 ? summaryColor : rowColor, decimal: averagePrecision, currency: isCurrency ? currency : undefined, value: data && !blankTotal ? item.total : undefined, percentage: props.percentage, bold: props.bold })), _jsx(StyledTableCell, { color: isMultiskill ? MULTISKILL_COLOR : summaryColor !== null && summaryColor !== void 0 ? summaryColor : rowColor, decimal: averagePrecision, colSpan: isIncludeTotal ? 1 : 2, highlightBorder: year !== arr.length - 1, percentage: props.percentage, currency: isCurrency ? currency : undefined, value: getAvg(year), bold: props.bold })] }, "period-group-".concat(startIdx)));
            })] }));
};
